<button
    class="btn option-btn btn-link dropdown-toggle"
    type="button"
    id="context-menu-{{ itemIndex }}"
    (click)="toggleContextMenu($event)"
    (contextmenu)="toggleContextMenu($event)"
>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
</button>
